export const TOPICS_IN_CHANNEL = 10;
export const COMMENTS_IN_TOPIC = 10;
export const SUBCOMMENTS_IN_COMMENTS = 10;
export const MESSAGES_IN_PAGE = 15;
